import styled from "styled-components";

export const ItemThumbnail = styled.span`
	position: relative;
	display: block;
	width: 64px;
	height: 64px;
	overflow: hidden;
	background: #f2f6fa;
	border-radius: 4px;

	img,
	video {
		width: 100%;
		height: 100%;
		object-fit: cover;
	}
`;

// The play mark of a video thumbnail.
export const ItemVideoBadge = styled.span`
	position: absolute;
	top: 50%;
	left: 50%;
	display: flex;
	align-items: center;
	justify-content: center;
	width: 28px;
	height: 28px;
	color: #fff;
	font-size: 14px;
	background: rgba(0, 0, 0, 0.5);
	border-radius: 50%;
	transform: translate(-50%, -50%);
`;

export const UploadActions = styled.div`
	display: flex;
	justify-content: flex-end;
`;
